import typography from '@assets/css/typography.css';

/**
 * Typography shared styles.
 * @type {CSSStyleSheet}
 */
export const typographySharedStyles = new CSSStyleSheet();
typographySharedStyles.replaceSync(typography);
